import { PasswordResetForm } from "../../components/pages/settings/passwordReset/Form";
import { SideMenu } from "../../components/pages/settings/sideMenu";

export const PasswordReset = () => {
  return (
    <div className="flex max-w-[1080px] mx-auto pt-8 px-4">
      <SideMenu />
      <PasswordResetForm />
    </div>
  );
};
